import { supabase } from "src/boot/supabase";
import routes from "src/router/routes";
import { collectTrackedPages, isValidPageKey } from "../domain/pageTracking";

const LEGACY_PAGE_LABELS = [
  { key: "immersive_reading", label: "Gratis mini-reading", path: "/reading" },
  {
    key: "home",
    label: "Home",
    path: "/",
  },
  {
    key: "parents_landing",
    label: "Landing voor ouders",
    path: "/voor-ouders",
  },
  {
    key: "shop",
    label: "Shop",
    path: "/shop",
  },
  {
    key: "soulprofile",
    label: "Soulprofile tool",
    path: "/soulprofile",
  },
  {
    key: "dayenergy",
    label: "Dagenergie",
    path: "/dagenergie",
  },
  {
    key: "book_landing",
    label: "Boek landing",
    path: "/boek",
  },
  {
    key: "clarity_landing",
    label: "Clarity sessie",
    path: "/clarity",
  },
  {
    key: "checkout_success",
    label: "Checkout afgerond",
    path: "/checkout/success",
  },
  {
    key: "checkout_cancelled",
    label: "Checkout afgebroken",
    path: "/checkout/cancelled",
  },
];

export const TRACKED_SITE_PAGES = collectTrackedPages(routes).map((page) => ({
  ...page,
  label: LEGACY_PAGE_LABELS.find((legacy) => legacy.key === page.key)?.label || page.label,
}));

export function isTrackedSitePageKey(pageKey) {
  return isValidPageKey(pageKey);
}

export async function trackSitePageView(pageKey) {
  if (!isTrackedSitePageKey(pageKey)) return false;

  const { data, error } = await supabase.functions.invoke("track-page-view", {
    body: { pageKey },
  });

  if (error) throw error;
  return data?.tracked === true;
}

export async function fetchSitePageViewDailyCounts() {
  const rows = [];
  const batchSize = 1000;
  for (let offset = 0; ; offset += batchSize) {
    const { data, error } = await supabase
      .from("site_page_view_daily_counts")
      .select("page_key, viewed_on, view_count")
      .order("viewed_on", { ascending: false })
      .order("page_key", { ascending: true })
      .range(offset, offset + batchSize - 1);
    if (error) throw error;
    rows.push(...(data || []));
    if (!data || data.length < batchSize) return rows;
  }
}
